import { FilterValues } from "../types/FilterValues";

export const filterValuesAreDefault = (filters: FilterValues) => {
  return Object.values(filters).every((value) => {
    return value === "Any";
  });
};
